






















































import BaseComponent from '@/components/base-component.vue';
import SplittedBagAddProdLocationDialog from '@/components/splitted-bag-config/splitted-bag-add-production-location-dialog.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import Component from 'vue-class-component';
import * as service from '@/services/splitted-bag-config';
import { filterByText } from '@/helpers/filterByText';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    SplittedBagAddProdLocationDialog
  }
})
export default class SplittedBagConfig extends BaseComponent {
  currentTab = null;
  search = null;

  list = [];
  loading = false;
  error = false;

  pagination: PaginationSyncDTO = new PaginationSyncDTO();

  editItem = null;
  openedAddDialog = false;

  public headers: any = [
    { text: 'UF', value: 'uf' },
    { text: 'Município', value: 'municipio' },
    { text: 'Data de produção - Ajuste', value: 'diasAjusteProducao', align: 'center' },
    { text: 'Dias de entrega', value: 'diasEntregaExtenso', sortable: false , align: 'center' },
    { text: 'Alterado por', value: 'usuarioAlteracao' },
    { text: 'Data alteração', value: 'dataAlteracao' },
    { text: '', value: '', sortable: false, width: '100px' }
  ];

  public customFilter(items, search, filter): any[] {
    const searchLower = search.toString().toLowerCase();
    return items.filter((row) => {
      return filterByText(row, ['uf', 'municipio', 'diasAjusteProducao'], searchLower);
    });
  }

  mounted() {
    this.pagination.sortBy = 'uf';
    this.pagination.descending = false;

    this.load();
  }

  load() {
    this.loading = true;
    this.error = false;
    service.listSplittedBagConfigs().subscribe(
      (res) => {
        this.loading = false;
        this.list = res;
      },
      (error) => {
        this.loading = false;
        this.error = true;
      }
    );
  }

  onBtnAddClick() {
    this.editItem = null;
    this.openedAddDialog = true;
  }

  onBtnEditClick(item) {
    this.editItem = item;
    this.openedAddDialog = true;
  }

  onCloseAddDialog() {
    this.openedAddDialog = false;
  }

  onSaveAddDialog() {
    this.openedAddDialog = false;
    this.load();
  }

  onDeleteClick(item) {
    this.dialog.show(
      'alert',
      'Confirme a exclusão',
      `Deseja excluir a configuração para ${item.municipio ? item.municipio + ' - ' : ''}${item.uf}?`,
      'Excluir',
      () => {
        this.loader.start();
        service.deleteSplittedBagConfigs(item.id).subscribe(
          (res) => {
            this.loader.stop();
            this.toast.show(res, 'success');
            this.onSaveAddDialog();
          },
          (error) => {
            this.loader.stop();
            this.showToastApiError(error);
          }
        );
      },
      'Voltar',
      () => {
        //nada
      },
      null,
      '400px'
    );
  }
}
